import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';

type Payload = {
  blockId: string;
  instructions: string;
  userId: string;
};

export const useAddUserBlock = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({ blockId, instructions, userId }: Payload) => {
      return await api({
        route: `/private/dashboard/user/${userId}/blocks/`,
        method: 'POST',
        token: userToken,
        payload: {
          block_id: blockId,
          instructions,
        },
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-blocks'],
      });
    },
  });

  return { mutation };
};
